<template>
  <v-container class="custom-container responsive-height">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-2"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-3 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable"
                  :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'"
                >
                  <v-data-table
                    :headers="headers"
                    :items="histories"
                    :items-per-page="5"
                  >
                    <template v-slot:item.DetailsView="{ item }">
                      <a
                        class="links text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="item.agreement_file"
                      >
                        <v-icon small color="#039de9">
                        mdi-eye-outline
                        </v-icon>
                      </a>
                    </template>

                    <template v-slot:item.agreement_file="{ item }">
                      <a
                        class="links text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="item.agreement_file"
                      >
                        <img
                          class="mt-2"
                          width="30px"
                          alt="pdf"
                          src="@/assets/pdf-sm.png"
                        />
                      </a>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>  

<script>
import { AGREEMENT__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Title", value: "title", align: "start" },
        { text: "Uploaded Date", value: "created_at" },
        { text: "PDF", value: "agreement_file" },
        { text: "Detail", value: "DetailsView" },
      ],
    };
  },
    computed: {
    ...mapState("agreements", ["histories"]),
  },
  methods: {
     ...mapActions("agreements", [AGREEMENT__ACTIONS.AGREEMENTHISTORIES]),

    verifyIcon(status) {
      if (status === "Accepted") return "mdi mdi-check text--green mr-1";
      else if (status === "Rejected")
        return "mdi mdi-window-close text-red mr-1";
      else return "mdi mdi-refresh mr-1 text-warning";
    },
  },
   async created() {
    await this[AGREEMENT__ACTIONS.AGREEMENTHISTORIES]();
  },
};
</script>
